import { isEmpty, isUndefined, merge } from 'lodash-es';

import { ChartInteractionsConfig } from '../types/interactions.js';

const defaultInteractions: ChartInteractionsConfig = {
  pan: { enabled: true },
  zoom: { enabled: true },
  zoomX: { enabled: true },
};

const oldDefaultInteractions: ChartInteractionsConfig = {
  pan: { enabled: false },
  zoom: { enabled: false },
  zoomX: { enabled: false },
};

export const getConfigPlusDefaultOrEmpty = (
  defaultConfig: ChartInteractionsConfig,
  config?: ChartInteractionsConfig,
) => {
  const isEmptyConfig = isEmpty(config) || isUndefined(config);
  return isEmptyConfig ? {} : merge({}, defaultConfig, config);
};

const getSlotsApiValuesOrFallbackIfHasOldConfig = (
  slotsChartInteractions: ChartInteractionsConfig,
  chartConfigInteractions?: ChartInteractionsConfig,
  oldApiValues?: ChartInteractionsConfig,
) => {
  const hasEmptySlotsAndChartConfig =
    isEmpty(slotsChartInteractions) && isEmpty(chartConfigInteractions);
  const hasOldApiValues = !isEmpty(oldApiValues) && !isUndefined(oldApiValues);

  if (hasEmptySlotsAndChartConfig && hasOldApiValues) {
    return oldApiValues;
  }

  return {
    ...defaultInteractions,
    ...chartConfigInteractions,
    ...slotsChartInteractions,
  };
};

export function getInteractions<T>(
  contextInteractions: ChartInteractionsConfig | undefined,
  slotsChartInteractions: ChartInteractionsConfig,
  propsInteractions: T = <T>{},
  chartConfigInteractions?: ChartInteractionsConfig,
) {
  const oldApiValues = getConfigPlusDefaultOrEmpty(
    oldDefaultInteractions,
    contextInteractions,
  );

  const slotsApiValues = getSlotsApiValuesOrFallbackIfHasOldConfig(
    slotsChartInteractions,
    chartConfigInteractions,
    oldApiValues,
  );

  return merge(
    {},
    oldApiValues,
    slotsApiValues,
    propsInteractions,
  ) as ChartInteractionsConfig;
}
